import React from 'react'

const TaskTitles = ({title,description}) => {
    return (
        <div className="mb-8">
            <h1 className='text-lg font-bold'>
                {title}
            </h1>
            <p className='text-sm text-gray-500'>
                {description}
            </p>
        </div>
    )
}

export default TaskTitles